
export class UpdateLookupVo {
  stateName?: string;
  gseAmt?: string;
  userID?: string;
}
